import { observer } from 'mobx-react'
import React, { FC } from 'react'

import { AccountStatus } from '@avantstay/arriere-clients/dist/arriereBackoffice'
import { capitalizeEachFirstLetter, CheckboxBasedFilter } from '@avantstay/backoffice-core'

import { FiltersSharedProps } from './Filters.types'

interface AccountStatusFilterProps extends FiltersSharedProps {
  initialValue?: string[]
  onChange: (value?: string[]) => void
}

const _AccountStatusFilter: FC<AccountStatusFilterProps> = props => {
  const disabledOptions = ['undefined', 'distribution']

  const accountStatusOptions = Object.keys(AccountStatus)
    .filter(accountModelKey => !disabledOptions.includes(accountModelKey))
    .map(accountModelKey => ({
      value: AccountStatus[accountModelKey as keyof typeof AccountStatus] as string,
      hasFullWidth: true,
      label: capitalizeEachFirstLetter(
        AccountStatus[accountModelKey as keyof typeof AccountStatus],
      ),
    }))

  return <CheckboxBasedFilter title="Account Status" options={accountStatusOptions} {...props} />
}

export const AccountStatusFilter = observer(_AccountStatusFilter)
